// removed by extract-text-webpack-plugin
module.exports = {"basewrapper":"_25Vsc","textwrapper":"_1t0tv _25Vsc"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Page/PageComponents/Text/Text.scss
 ** module id = 449
 ** module chunks = 0
 **/